import { Controller } from '@hotwired/stimulus';
import axios from "axios";
import {load} from "recaptcha-v3";

export default class extends Controller {
    async connect() {
        this.formController = Stimulus.getControllerForElementAndIdentifier(this.element, 'axios-form');

        this.inputs = {
            phone: this.element.querySelector('input[data-name="phone"]'),
        };

        const siteKey = this.element.hasAttribute('data-site-key') ? this.element.getAttribute('data-site-key') : undefined;
        const recaptcha = siteKey ? await load(siteKey) : undefined;

        //password toggle who
        this.verificationCodeSubmitButton = this.element.querySelector('#verificationCodeSubmitButton');
        const passwordChangeToggle = this.element.querySelector('#passwordChangeToggle');
        const passwordChangeForm = this.element.querySelector('#passwordChangeForm');

        if (passwordChangeToggle && passwordChangeForm) {
            passwordChangeToggle.addEventListener('input', () => {
                if (passwordChangeToggle.checked) {
                    passwordChangeForm.classList.remove('d-none');
                } else {
                    passwordChangeForm.classList.add('d-none');
                }
            })
        }

        if (this.inputs.phone && this.verificationCodeSubmitButton) {
            this.verificationCodeSubmitButton.addEventListener('click', async (e) => {
                e.preventDefault();
                const token = recaptcha ? await recaptcha.execute('submit') : undefined;
                this.sendVerificationCode(token);
            });
        }
    }

    sendVerificationCode(token) {
        if (this.verificationCodeSubmitButton.classList.contains('loading')) {
            return;
        }

        this.verificationCodeSubmitButton.classList.add('loading');

        this.verificationCodeSubmitButton.disabled = true;
        this.verificationCodeSubmitButton.classList.add('disabled');

        const disableTimeout = setTimeout(() => {
            this.verificationCodeSubmitButton.disabled = false;
            this.verificationCodeSubmitButton.classList.remove('disabled');
        }, 60000);

        const url = '/wp-json/api/send-verification-code?rest_language=' + this.currentLanguageCode;

        let formData = new FormData;
        formData.append('phone', this.element.querySelector('input[name="phone"]').value);
        formData.append('personal_code', this.element.querySelector('input[name="personal_code"]').value);

        if (token) {
            formData.append('token', token);
        }

        this.formController.removeFormNotes();

        axios.post(url, formData).then((response)=>{
            this.verificationCodeSubmitButton.classList.remove('loading');
            response = response.data.data;

            if (!response.success) {
                clearTimeout(disableTimeout);
                this.verificationCodeSubmitButton.disabled = false;
                this.verificationCodeSubmitButton.classList.remove('disabled');
            }

            this.handleFormResponse(response);
        }).catch((error)=>{
            this.verificationCodeSubmitButton.classList.remove('loading');
            const response = error.response.data.data;

            if (response && response.errors && Object.keys(response.errors).length) {
                this.formController.setupFormErrors(response.errors);
            }

            clearTimeout(disableTimeout);

            this.verificationCodeSubmitButton.disabled = false;
            this.verificationCodeSubmitButton.classList.remove('disabled');
        });
    }

    handleFormResponse(response) {
        if (response && response.general_error) {
            this.formController.setupFormGeneralError(response);

        } else if (response && response.general_success) {
            this.formController.setupFormGeneralSuccess(response);
        } else if (response && response.action && response.action === 'show_popup') {
            if (response.action_data) {
                const popup = document.getElementById('global-popup');

                if (popup) {
                    const popupController = Stimulus.getControllerForElementAndIdentifier(popup, 'modal');

                    if (popupController) {
                        const content = popup.querySelector('.modal-inner');
                        content.innerHTML = response.action_data;
                        popupController.showModal();
                    }
                }
            }
        } else if (response && response.redirect) {
            window.location.href = response.redirect;

        } else if (response && response.reload) {
            window.location.reload();

        } else {
            if (!response || !response.action) {
                this.formController.setupFormUnexpectedError();
            }
        }
    }
}
